import { useState } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Activities } from "src/modules/activity-log/activity";
import { getAppValue } from "src/utils/environment";
import RoundButton from "src/components/RoundButton";
import MotionInfo from "./MotionInfo";
import MotionErrorDialog from "src/modules/motion-detection/components/MotionErrorDialog";
import { ReactComponent as MotionBaby } from "./motion-baby.svg";
import { ReactComponent as MotionDog } from "./motion-dog.svg";
import { ReactComponent as ErrorIcon } from "./motion-error.svg";

export default function MotionButton({
  activity,
  toggleMotionSettings,
  indicateMotion,
  canDetectMotion
}) {
  const [motionInfo, setMotionInfo] = useState({
    isOpen: false,
    close: () =>
      setMotionInfo((prevState) => ({ ...prevState, isOpen: false })),
    open: () => setMotionInfo((prevState) => ({ ...prevState, isOpen: true }))
  });
  const [motionErrorDialog, setMotionErrorDialog] = useState({
    isOpen: false,
    close: () =>
      setMotionErrorDialog((prevState) => ({ ...prevState, isOpen: false })),
    open: () =>
      setMotionErrorDialog((prevState) => ({ ...prevState, isOpen: true }))
  });
  return (
    <>
      <Flex zIndex="100" position="fixed" bottom="16px" right="16px">
        <Box position="relative">
          <RoundButton
            icon={getAppValue({
              bibino: MotionBaby,
              barkio: MotionDog
            })}
            size={["48px", "62px", "72px"]}
            iconFill={
              activity === Activities.MOTION || indicateMotion
                ? "white"
                : "white40"
            }
            bg="black20"
            iconSize="24px"
            onClick={canDetectMotion ? motionInfo.open : motionErrorDialog.open}
          />
          {!canDetectMotion && (
            <Box position="absolute" bottom="0" right="0">
              <ErrorIcon />
            </Box>
          )}
        </Box>
      </Flex>
      <MotionInfo
        isOpen={motionInfo.isOpen}
        onClose={motionInfo.close}
        toggleMotionSettings={toggleMotionSettings}
      />
      <MotionErrorDialog
        motionDetectorState="STOPPED_REASON_LOW_CAMERA_EXPOSURE"
        isOpen={motionErrorDialog.isOpen}
        onClose={motionErrorDialog.close}
      />
    </>
  );
}
